import { api } from "@/redux/api";

import {
	SenderCopywritingPreference,
	SenderCopywritingPreferenceSchema,
	UpsertSenderCopywritingPreferenceRequest,
	UpsertSenderCopywritingPreferenceSchema,
} from "./senderCopywriting.schema";

/**
 * RTK Query endpoints for the sender copywriting preference (PREC-3719 §6).
 * Mirrors apps/api/src/sender-copywriting-preference/*.controller.ts.
 */
export const senderCopywritingApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getSenderCopywritingPreference: builder.query<SenderCopywritingPreference, void>({
			query: () => ({
				url: "sender-copywriting-preference",
				responseSchema: SenderCopywritingPreferenceSchema,
			}),
			providesTags: ["SenderCopywritingPreference"],
		}),
		upsertSenderCopywritingPreference: builder.mutation<
			SenderCopywritingPreference,
			UpsertSenderCopywritingPreferenceRequest
		>({
			query: (body) => ({
				url: "sender-copywriting-preference",
				method: "PUT",
				body,
				requestSchema: UpsertSenderCopywritingPreferenceSchema,
				responseSchema: SenderCopywritingPreferenceSchema,
			}),
			invalidatesTags: ["SenderCopywritingPreference"],
		}),
	}),
});

export const {
	useGetSenderCopywritingPreferenceQuery,
	useUpsertSenderCopywritingPreferenceMutation,
} = senderCopywritingApi;
